const company = {
	details: {
		/* ----------------------------- ABRECHNUNGSBEREICH ---------------------------- */
		billing: {
			description: "In diesem Abschnitt finden Sie Ihre Abrechnungsdetails.",
			status: {
				success: "Ihre Abrechnungsdetails wurden erfolgreich aktualisiert!",
			},
			title: "Abrechnungsdetails",
		},

		/* -------------------------- COMMUNICATION SECTION ------------------------- */
		communication: {
			description: "In diesem Abschnitt können Sie Ihre Kommunikationspräferenzen angeben.",
			general: {
				error: "Fügen Sie der allgemeinen Mailingliste mindestens eine E-Mail-Adresse hinzu.",
				title: "Mailingliste Allgemeine Angelegenheiten",
			},
			invoice: {
				error: "Fügen Sie mindestens eine E-Mail-Adresse in den Verteiler für Angebote ein.",
				title: "Mailinglisten-Angebote",
			},
			language: {
				tip: "Dies ist die Sprache, in der E-Mails, Rechnungen und Angebote versendet werden.",
				title: "Kommunikationssprache",
			},
			pbs: {
				messages: {
					success: "E-Mail-Adresse für PBS-Fehlermeldungen erfolgreich aktualisiert.",
				},
				placeholder: "Zum Beispiel fehlermeldungen@example.de",
				title: "E-Mail-Adresse für PBS-Fehlermeldungen",
			},
			status: {
				mailing_list: {
					duplicate:
						"Die von Ihnen eingegebene E-Mail-Adresse befindet sich bereits in dieser Liste.",
					success: "Ihre Mailingliste wurde erfolgreich aktualisiert!",
				},
			},
			title: "Kommunikationspräferenzen",
		},
		company: {
			description:
				"In diesem Abschnitt finden Sie die allgemeinen Ansprechpartner dieses Unternehmens",
			success: "Der allgemeine Ansprechpartner dieses Unternehmens wurde erfolgreich aktualisiert!",
			title: "Allgemeiner Ansprechpartner",
		},

		/* ------------------------- CONTACT DETAILS SECTION ------------------------ */
		contact_details: {
			description:
				"Geben Sie hier die Daten der Person ein, die für die Bestellungen verantwortlich ist und als allgemeiner Ansprechpartner für Tuxis dient.",
			emergency: {
				title: "Notfallnummer",
			},
			messages: {
				success: "Die Daten wurden erfolgreich geändert!",
			},
			title: "Allgemeiner Ansprechpartner",
		},
		direct_debit: {
			account_holder: {
				label: "Name des Kontoinhabers",
				placeholder: "Zum Beispiel Max Mustermann",
			},
			account_number: {
				invalid_iban: "Diese IBAN-Nummer scheint nicht korrekt zu sein.",
				label: "Kontonummer (IBAN)",
				placeholder: "Zum Beispiel NL00 BANK 0012 3456 78",
			},
			bank_location: {
				label: "Bankstandort",
				placeholder: "Zum Beispiel Berlin",
			},
			bank_name: {
				label: "Bankname",
				placeholder: "Zum Beispiel Deutsche Bank",
			},
			bic_code: {
				label: "BIC-Code",
				placeholder: "Zum Beispiel DEUTDEFF",
			},
			is_active: {
				checkbox_text: "Lastschrift aktivieren",
				label: "Lastschrift",
			},
			messages: {
				success: "Lastschriftinformationen erfolgreich aktualisiert!",
			},
		},
	},
	tabs: {
		company_details: "Details zum Unternehmen",
		invoices: "Rechnungen",
		orders: "Bestellungen",
		user_management: "Benutzerverwaltung",
	},
	title: "Ihr Unternehmen",
};

export default company;
